import {
  ADD_ORDERED_RULES,
  BACKUP_RULES,
  CREATE_RULE_SUCCESS,
  CREATING_RULE,
  FETCH_RULE_SUCCESS,
  FETCH_RULES_SUCCESS,
  FETCH_SUBTYPES_SUCCESS,
  FETCHING_RULE,
  FETCHING_RULES,
  RE_ORDER_RULES_SUCCESS,
  REMOVE_ORDERED_RULE,
  RESET_RULE_CREATOR,
  RESTORE_RULES,
  RULES_SUBTYPES_ORDER,
  UPDATE_SELECTED_RULES_SUCCESS,
  VALIDATE_RULE_ERROR,
  VALIDATE_RULE_RESET,
  VALIDATE_RULE_SUCCESS,
  VALIDATING_RULE,
  APPLY_ALLOCATION_SUCCESS,
  APPLYING_ALLOCATION_RULE
} from './RulesConstants';
import {
  ADD_RULES_IDS_TO_PROFILE,
  RESET_PROFILE,
  SET_PROFILE_FOR_EDITION
} from '../profiles/ProfilesConstants';

const initialStore = {
  rules: [],
  rule: {},
  selectedRules: [],
  backupSelectedRules: [],
  orderedRules: [],
  backupOrderedRules: [],
  pageState: {
    page: 0,
    perPage: 10,
    totalEntries: 0,
    totalPages: 0
  },
  validationResult: '',
  validatingRule: false,
  subtypes: [],
  fetchingRule: false,
  fetchingRules: false,
  orderHasChanged: false,
  creatingRule: false,
  applyingAllocationRule: false
};

const addOrRemoveSelectedRule = (oldStateSelectedRules, rule) => {
  const oldRules = [...oldStateSelectedRules];
  const rulePosition = oldRules.findIndex(
    currentRule => currentRule.id === rule.id
  );
  if (rulePosition === -1) {
    oldRules.push(rule);
    return oldRules;
  } else {
    oldRules.splice(rulePosition, 1);
    return oldRules;
  }
};

const areRulesDifferent = (orderedRules, backupOrderedRules) =>
  orderedRules.length !== backupOrderedRules.length
    ? true
    : orderedRules.findIndex(
      (rule, index) => rule.id !== backupOrderedRules[index].id
    ) >= 0;

const mapRuleFromBackend = ({
  id,
  name,
  description,
  subtype,
  postCalculation
}) => ({
  id,
  name,
  description,
  subtype,
  mergedSubtype:
    subtype === 'POSTED'
      ? 'POSTED'
      : `${subtype}-${postCalculation ? 'POST' : 'PRE'}`
});

const RulesReducer = (state = initialStore, action) => {
  let orderedRules;
  let offset;
  switch (action.type) {
    case FETCH_RULES_SUCCESS:
      return {
        ...state,
        rules: action.rules.map(
          ({ id, name, description, type, subtype, postCalculation }) => ({
            id,
            name,
            description,
            type,
            subtype,
            postCalculation,
            mergedSubtype:
              subtype === 'POSTED'
                ? 'POSTED'
                : `${subtype}-${postCalculation ? 'POST' : 'PRE'}`
          })
        ),
        pageState: action.pageState,
        fetchingRules: false
      };
    case FETCHING_RULES:
      return {
        ...state,
        fetchingRules: true,
        pageState: {
          ...initialStore.pageState,
          page: action.pageStats.page,
          perPage: action.pageStats.perPage
        }
      };
    case BACKUP_RULES:
      return {
        ...state,
        backupSelectedRules: state.selectedRules.map(rule => ({ ...rule })),
        backupOrderedRules: state.orderedRules.map(rule => ({ ...rule })),
        orderHasChanged: false
      };
    case RESTORE_RULES:
      return {
        ...state,
        selectedRules: state.backupSelectedRules.map(rule => ({ ...rule })),
        orderedRules: state.backupOrderedRules.map(rule => ({ ...rule }))
      };
    case UPDATE_SELECTED_RULES_SUCCESS:
      return {
        ...state,
        selectedRules: addOrRemoveSelectedRule(state.selectedRules, action.rule)
      };
    case ADD_ORDERED_RULES:
      orderedRules = RULES_SUBTYPES_ORDER.map(subtype => [
        ...state.orderedRules.filter(oRule => oRule.mergedSubtype === subtype),
        ...state.selectedRules.filter(sRule => sRule.mergedSubtype === subtype)
      ]).flatten();
      return {
        ...state,
        orderedRules,
        selectedRules: [],
        orderHasChanged: areRulesDifferent(
          orderedRules,
          state.backupOrderedRules
        )
      };
    case REMOVE_ORDERED_RULE:
      offset = state.orderedRules.findIndex(
        rule => rule.mergedSubtype === action.subtype
      );
      orderedRules = state.orderedRules
        .slice(0, action.index + offset)
        .concat(state.orderedRules.slice(action.index + offset + 1));
      return {
        ...state,
        orderedRules,
        orderHasChanged: areRulesDifferent(
          orderedRules,
          state.backupOrderedRules
        )
      };
    case ADD_RULES_IDS_TO_PROFILE:
      return { ...state, selectedRules: [] };
    case VALIDATING_RULE:
      return { ...state, validatingRule: true };
    case VALIDATE_RULE_ERROR:
      return {
        ...state,
        validationResult:
          'Error while validating Rule, contact system administrator'
      };
    case VALIDATE_RULE_SUCCESS:
      return {
        ...state,
        validationResult: action.validationResult,
        validatingRule: false
      };
    case VALIDATE_RULE_RESET:
      return { ...state, validationResult: '' };
    case RE_ORDER_RULES_SUCCESS: //eslint-disable-line no-case-declarations
      orderedRules = [...state.orderedRules];
      offset = orderedRules.findIndex(
        rule => rule.mergedSubtype === action.subtype
      );
      const [removed] = orderedRules.splice(action.startIndex + offset, 1);
      orderedRules.splice(action.endIndex + offset, 0, removed);
      return {
        ...state,
        orderedRules,
        orderHasChanged: areRulesDifferent(
          orderedRules,
          state.backupOrderedRules
        )
      };
    case FETCH_SUBTYPES_SUCCESS:
      return { ...state, subtypes: action.subtypes };
    case CREATING_RULE:
      return { ...state, creatingRule: true };
    case CREATE_RULE_SUCCESS:
      return { ...state, creatingRule: false };
    case RESET_RULE_CREATOR:
      return { ...state, validatingRule: false, validationResult: '' };
    case APPLY_ALLOCATION_SUCCESS:
      return { ...state, applyingAllocationRule: false };
    case APPLYING_ALLOCATION_RULE:
      return {
        ...state,
        applyingAllocationRule: true
      };
    case SET_PROFILE_FOR_EDITION:
      return {
        ...state,
        orderedRules: action.profile.ruleSets.rules.map(mapRuleFromBackend),
        backupOrderedRules: action.profile.ruleSets.rules.map(
          mapRuleFromBackend
        )
      };
    case RESET_PROFILE:
      return { ...initialStore, pageState: { ...initialStore.pageState } };
    case FETCHING_RULE:
      return { ...state, fetchingRule: true, fetchingRules: true };
    case FETCH_RULE_SUCCESS: {
      let formatedCostObjects = [];
      if (action.rule.costObjects) {
        formatedCostObjects = action.rule.costObjects.map(costObject => {
          if (costObject.percentageOfGross === null) {
            return { ...costObject, percentageOfGross: '' };
          } else if (costObject.amount === null) {
            return { ...costObject, amount: '' };
          }
        });
      }
      return {
        ...state,
        fetchingRule: false,
        fetchingRules: false,
        rule:
          formatedCostObjects.length > 0
            ? { ...action.rule, costObjects: formatedCostObjects }
            : action.rule
      };
    }
    default:
      return { ...state };
  }
};

export default RulesReducer;



// WEBPACK FOOTER //
// ./src/redux/rules/RulesReducer.js